import { useEffect } from "react";
import "./book.css";

function EbookBuy() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://gumroad.com/js/gumroad.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <div className="cover-container">
        <img src="https://i.imgur.com/hukR75h.png" alt="" className="cover" />
        <div className="cover-text">
          <p className="cover-p">
            A 29-page Jersey City guide covering dog training basics, finding
            trusted walkers and sitters, and the best dog-friendly cafés, parks,
            beaches, vets, groomers, and trainers.
          </p>
        </div>
      </div>
      <a
        href="https://zekeriyacnl.gumroad.com/l/afpxm?wanted=true"
        data-gumroad-overlay="true"
        className="ebook-button"
      >
        Get the Guide
      </a>
    </div>
  );
}

export default EbookBuy;
